import React, { useState } from "react"
import {
  Paper,
  List,
  ListItem,
  ListItemText,
  Typography,
  InputBase,
  Box,
  Divider,
} from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import useTranslationSharie from "../hooks/Language/useTranslation"

const BusinessList = ({ businesses }) => {
  const [search, setSearch] = useState("")
  const t = useTranslationSharie()

  const handleSearchChange = (event) => {
    setSearch(event.target.value)
  }

  const filteredBusinesses = businesses.filter((business) =>
    business?.name?.toLowerCase().includes(search?.toLowerCase())
  )

  return (
    <Paper
      sx={{
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: 4,
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          background: (theme) =>
            `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          color: "text.primary",
          p: 2,
        }}
      >
        <Typography variant='h6' fontWeight='bold'>
          {t("Business")}
        </Typography>
        <Typography variant='body2'>{t("Find business to co-op with")}</Typography>
      </Box>

      {/* SEARCH BAR */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 2,
          py: 1,
          bgcolor: "grey.100",
        }}
      >
        <SearchIcon color='primary' sx={{ mr: 1 }} />
        <InputBase
          placeholder={t("Search Business")}
          value={search}
          onChange={handleSearchChange}
          sx={{
            flex: 1,
          }}
        />
      </Box>

      <Divider />

      {/* BUSINESS LIST */}
      <Box sx={{ flexGrow: 1, overflowY: "auto", p: 2 }}>
        {filteredBusinesses.length > 0 ? (
          <List disablePadding>
            {filteredBusinesses.map((business) => (
              <ListItem
                key={business.id}
                sx={{
                  borderBottom: "1px solid",
                  borderColor: "grey.200",
                  px: 0,
                }}
              >
                <ListItemText
                  primary={
                    <Typography variant='h6' color='primary'>
                      {business.name}
                    </Typography>
                  }
                  secondary={
                    <Typography variant='body2' color='text.secondary'>
                      {`${business.city}, ${business.country} - ${business.description}`}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography variant='body2' color='textSecondary' align='center' sx={{ mt: 2 }}>
            {t("No businesses found")}
          </Typography>
        )}
      </Box>
    </Paper>
  )
}

export default React.memo(BusinessList)
